import { useEffect } from "react";
import "react-sortable-tree/style.css";
import { LoaderV2 } from "#src/commonV2/LoadingState";
import {
  createSearchParams,
  generatePath,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { pathname } from "#src/config/pathname";
import { SYNC_DIRECTORY_WORKSPACE_SESSION_STORAGE_KEY } from "#src/services/endpoint/directory/types";

const GoogleCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const code = searchParams.get("code");
    const workspaceId = sessionStorage.getItem(
      SYNC_DIRECTORY_WORKSPACE_SESSION_STORAGE_KEY
    );

    if (code && workspaceId) {
      navigate({
        pathname: generatePath(pathname.ENDPOINT_DIRECTORY_USERS, {
          workspaceId,
        }),
        search: createSearchParams({
          code,
        }).toString(),
      });
    } else {
      navigate("/");
    }
  }, [navigate, searchParams]);

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <LoaderV2 baseSize={5} />
    </div>
  );
};

export default GoogleCallbackPage;
